import React, { useState, useEffect } from "react";
import { TextField, Typography, styled, Box ,Dialog, DialogContent} from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import Profit from "../../images/profit.svg";
import Loss from "../../images/loss.svg";
import Incoming from "../../images/incoming.png";
import Outgoing from "../../images/outgoing.png";
import Balance from "../../images/balance.png";
import Bring from "../../images/bring.png";
import LoopIcon from "@mui/icons-material/Loop";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { Button, FormControl, Grid } from "@mui/material";
import DataTableComponent from "../reusableComponents/DataTable";
import SalesRepository from "../../Repository/SalesRepository";
import moment from "moment";
import DialogComponent from "../reusableComponents/Dialog";
import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";
import DateBookRepository from "../../Repository/DateBookRepository";
import CategoriesList from "./CategoriesList";
import AddCategory from "./AddCategory";
import { useDispatch, useSelector } from "react-redux";
import { getCategories } from "./categorySlice";
import UpdateTransaction from "./UpdateTransaction";
import { Toast } from "../components/Toast";
import AddTransaction from "./AddTransaction";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { removeTransaction } from "./transactionSlice";
import { submitTransaction } from "./httpCalls";
import { QrCodeScannerOutlined } from "@mui/icons-material";
import Repo from "../../Repository/Repo";
import html2pdf from "html2pdf.js";

const ValueBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "30px",
  background: "#F9F9F9",
  width: "130px",
});
const CardBox = styled(Box)({
  backgroundColor: "white",
  borderRadius: "3px",
  height: "100px",
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
});
const CardValues = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "30px",
  background: "#E0E0E0 ",
  width: "100%",
  alignSelf: "flex-end",
});
const ProfitBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: "90px",
  background: "#4eaf51",
  padding: "10px",
  borderRadius: "6px",
});

const Btn = styled(Button)({
  background: "#4EAF51 !important",
  color: "white",
});

const customStyles = {
  rows: {
    style: {
      minHeight: "60px !important",
      background: "white",
      padding: "2px 10px",
      marginTop: "5px",
      borderRadius: "7px",
      "&:hover": {
        borderRight: "solid 1px",
        borderLeft: "solid 1px",
      },
    },
  },

  headRow: {
    style: {
      background: "#4EAF50",
      padding: "2px 10px",
      marginTop: "5px !important",
      borderRadius: "7px",
    },
  },

  table: {
    style: {
      background: "#EBEBEB",
      marginBottom: "20px",
    },
  },

  header: {
    style: {
      color: "#4EAF50",
      background: "white",
      borderRadius: "7px",
    },
  },

  headCells: {
    style: {
      color: "white",
      fontSize: "16px",
    },
  },
};

function dailyBook() {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.daybookCat.categories);
  const { transactions } = useSelector((state) => state.transaction);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [transaction, setTransaction] = useState({
    nameNumber: "",
    broughtForward: "",
    amount: 0,
    date: "",
    category: "",
  });
  const [transModal, setTransModal] = useState(false);
  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectCategory, setSelectCategory] = useState("");
  const [state, setState] = useState({
    profit: 0,
    loss: 0,
    balance: 0,
    incoming: 0,
    outgoing: 0,
    broughtForward: 0,
    daybook: [],
    datebook: {},
    loading: false,
    isSearched: false,
    isNew: false,
    categoryModal: false,
    listModal: false,
  });
  console.log("date", state.daybook);
  const [selected, setSelected] = useState(null);
  const [selIndex, setSelIndex] = useState(null);
  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showOffline, setShowOffline] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImg, setSelectedImg] = useState(false);


  const [syncIdx, setSyncIdx] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  useEffect(() => {
    if (isOnline || navigator.isOnline) {
      getDayBook();
      if (categories.length == 0) {
        dispatch(getCategories());
      }
    }
    window.addEventListener("online", checkConnection);
    window.addEventListener("offline", checkConnection);

    return () => {
      window.removeEventListener("online", checkConnection);
      window.removeEventListener("offline", checkConnection);
    };
  }, []);

  const recordAdded = () => {
    transToggle();
    getDayBook();
  };

  const toggleOffline = () => {
    setShowOffline((prev) => !prev);
  };

  const deleteToggle = (arg = "") => {
    setDeleteModal((prev) => !prev);
    if (arg) {
      setSelIndex(arg);
    }
  };
  const deleteModalHandler = (row) => {
    deleteToggle(row);
    setSelectedRow(row);
  };
  const handleDelete = async (row) => {
    dispatch(removeTransaction({ index: selIndex }));

    try {
      const response = await Repo.datebook({
        request: {
          method: "deleteDateBook",
          data: {
            _id: selectedRow?._id,
          },
        },
      });
      if (response.data.response.status.statusCode === 200) {
        if (date.startDate && date.endDate) {
          getRangeValue();
        } else {
          getDayBook();
        }
        deleteToggle();
      }
      // Process the response as needed
      console.log("Response:", response);
      return response;
    } catch (error) {
      // Handle any errors that occur during the request
      console.error("Error updating bill status:", error);
      throw error;
    }
  };

  const openModelHandler = (img) => {
    setOpenModal((prev) => !prev);
    setSelectedImg(img);

  };
  const checkConnection = () => {
    if (navigator.onLine) {
      Toast("success", "Internet Restored");
      setIsOnline(true);
    } else {
      if (isOnline) {
        setIsOnline(false);
        Toast("info", "Internet Down");
      }
    }
  };

  const offlineCols = [
    {
      name: "Details",
      cell: (row) => row?.nameNumber || "NA",
    },
    {
      name: "Details",
      cell: (row) => row?.nameNumber || "NA",
    },
    {
      name: "Outgoing",
      cell: (row) => row?.debit,
    },
    {
      name: "Incoming",
      cell: (row) => row?.credit,
    },

    {
      name: "Date",
      selector: (row) => moment(row?.date).format("DD-MM-YYYY"),
    },
    {
      name: "Action",
      cell: (row, i) => {
        return (
          <Stack direction="row" alignItems="center" spacing={2}>
            <i
              style={{ cursor: "pointer" }}
              onClick={() =>
                syncLoading && syncIdx[row.created_at]
                  ? null
                  : handleEdit(row, i)
              }
              className="fas fa-edit"
            ></i>
            <DeleteForeverIcon
              sx={{ color: "red", cursor: "pointer" }}
              onClick={() =>
                syncLoading && syncIdx[row.created_at] ? null : deleteToggle(i)
              }
            />
            {showOffline && (
              <Box>
                {syncLoading && syncIdx[row.created_at] ? (
                  <Box sx={{ ml: 2 }}>
                    <ClipLoader size={25} color="#4eaf51" loading={true} />
                  </Box>
                ) : (
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ textTransform: "none" }}
                    onClick={() => handleSync(row, i)}
                  >
                    Sync
                  </Button>
                )}
              </Box>
            )}
          </Stack>
        );
      },
    },
  ];
  const columns = [
    {
      name: "Image",
      center: true,
      cell: (row) =>
        row?.imgURL ? (
          <img
            src={row.imgURL} // The image URL from the row
            alt={row.nameNumber || "Image"}
            style={{ width: "50px", height: "50px", objectFit: "cover" }} // Adjust size as needed
            onClick={()=>openModelHandler(row.imgURL)}
          />
        ) : (
          "NA" // Fallback if no image URL is provided
        ),
    },
    {
      name: "Details",
      center: true,
      cell: (row) =>
        row?.nameNumber ? row?.nameNumber : row?.category || "NA",
    },
    {
      name: "Outgoing",
      center: true,
      cell: (row) => row?.debit,
    },
    {
      name: "Incoming",
      center: true,
      cell: (row) => row?.credit,
    },
    {
      name: "Date",
      center: true,
      selector: (row) => moment.unix(row?.created_at).format("DD-MM-YYYY"),
    },
    {
      width: "50px",
      name: "",
      center: true,
      cell: (row) => {
        return (
          <>
            {row?.recordType === "Manual Entry" && (
              <i
                style={{ marginLeft: "20px", cursor: "pointer" }}
                onClick={() => {
                  handleEdit(row);
                }}
                className="fas fa-edit"
              ></i>
            )}
            <i
              style={{ marginLeft: "20px", cursor: "pointer" }}
              onClick={() => {
                deleteModalHandler(row);
              }}
              className="fas fa-trash"
            ></i>
          </>
        );
      },
    },
  ];

  const handleEdit = (item, idx) => {
    setSelected(item);
    setSelIndex(idx);
    setModal(true);
  };

  // const handleDelete = (item, idx) => {

  // };

  const newToggle = (name) => {
    setModal((prev) => !prev);
  };
  const toggle = (name) => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const transToggle = () => {
    setTransModal((prev) => !prev);
    if (transModal) {
      setTransaction({
        nameNumber: "",
        broughtForward: "",
        amount: 0,
        date: "",
        category: "",
      });
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDate((prev) => ({ ...prev, [name]: value }));
    if (name == "startDate" && value && date.endDate != "") {
      getRangeValue(value, date.endDate != "", selectCategory);
    } else if (name == "endDate" && value && date.startDate != "") {
      getRangeValue(date.startDate, value, selectCategory);
    } else if (state.isSearched) {
      getDayBook();
      setState({
        ...state,
        isSearched: false,
      });
    }
  };

  const getRangeValue = async (startDate, endDate, category) => {
    let start = startDate ? moment(startDate).format("DD-MM-YYYY") : "";
    let end = endDate ? moment(endDate).format("DD-MM-YYYY") : "";
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await DateBookRepository.datebookModel({
      request: {
        method: "getRangeDateBookByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
          startDate: start,
          endDate: end,
          category: category,
        },
      },
    });

    let resp = await SalesRepository.salesModel({
      request: {
        method: "getSalesProfitByRange",
        data: {
          company_code: localStorage.getItem("companyCode"),
          startDate: start,
          endDate: end,
        },
      },
    });

    setState({
      ...state,
      profit: resp.data.response.data.sales.profit,
      loss: resp.data.response.data.sales.loss,
      balance: data.response.data.balance.balance,
      incoming: data.response.data.balance.incoming,
      outgoing: data.response.data.balance.outgoing,
      broughtForward: data.response.data.balance.broughtForward,
      daybook: data.response.data.dateBook,
      loading: false,
      isSearched: true,
    });
  };

  const getDayBook = async () => {
    setState({ ...state, loading: true });
    let resps = await SalesRepository.salesModel({
      request: {
        method: "getSalesDailyProfit",
        data: {
          company_code: localStorage.getItem("companyCode"),
          date: moment().format("DD-MM-YYYY"),
        },
      },
    });

    let result = await DateBookRepository.datebookModel({
      request: {
        method: "getDateBookByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
          date: moment().format("DD-MM-YYYY"),
        },
      },
    });

    let isNew = false;
    if (Object.keys(result.data.response.data.balance).length == 0) {
      isNew = true;
    }

    setState({
      datebook: result.data.response.data.balance,
      daybook: result.data.response.data.dateBook,
      broughtForward: result.data.response.data.balance.broughtForward,
      balance: result.data.response.data.balance.balance,
      incoming: result.data.response.data.balance.incoming,
      outgoing: result.data.response.data.balance.outgoing,
      profit: resps.data.response.data.sales.profit,
      loss: resps.data.response.data.sales.loss,
      loading: false,
      isNew,
    });
  };

  const searchedItems = () => {
    return state.daybook.filter((it) => it.credit != it.debit);
  };

  const printDoc = () => {
   
    const pdfContent = `
<div id="pdf-content" style="font-family: Arial, sans-serif;">
  <div style="text-align: center; font-size: 26px; font-weight: bold;">DAY BOOK REPORT</div>
  <div style="margin-top: 10px; text-align: right; font-size: 12px;">
    Date: ${moment().format("DD-MM-YYYY")}
  </div>
  <div style="margin-top: 20px;">
    <div>${localStorage.getItem("company") || ""}</div>
    <div>${localStorage.getItem("address") || ""}</div>
    <div>${localStorage.getItem("phone") || ""}</div>
  </div>
  <div style="margin-top: 20px; font-size: 14px; font-weight: bold;">
    <div style="display: flex; justify-content: space-between;">
          <span>Category</span>
      <span>Details</span>
      <span>Outgoing</span>
      <span>Incoming</span>
      <span>Date</span>
    </div>
  </div>
<div style="margin-top: 10px; border: 1px solid black;">
  ${state.daybook
    .filter((it) => it.credit != it.debit)
    .map((item) => {
      return `
        <div style="display: flex; justify-content: space-between; border-bottom: 1px solid black; padding: 5px;">
          <span style="flex: 1; text-align: center; border-right: 1px solid black;">${
            item?.category || "NA"
          }</span>
          <span style="flex: 2; text-align: center; border-right: 1px solid black;">${
            item?.nameNumber || "NA"
          }</span>
          <span style="flex: 1; text-align: center; border-right: 1px solid black;">${
            item.debit || 0
          }</span>
          <span style="flex: 1; text-align: center; border-right: 1px solid black;">${
            item.credit || 0
          }</span>
          <span style="flex: 1; text-align: center;">${moment
            .unix(item.created_at)
            .format("DD-MM-YYYY")}</span>
        </div>`;
    })
    .join("")}
</div>

  <div style="margin-top: 20px;">
    <div>Total Profit: ${state.profit || 0}</div>
    <div>Total Loss: ${state.loss || 0}</div>
    <div>Total Sale: ${state.incoming || 0}</div>
    <div>Total Expense: ${state.outgoing || 0}</div>
    <div>Closing Balance: ${state.balance || 0}</div>
  </div>
  <div style="margin-top: 30px; text-align: center; font-size: 10px;">
    <div>${localStorage.getItem("terms") || ""}</div>
  </div>
</div>
`;

    // Add the HTML content to the page
    document.body.innerHTML += pdfContent;

    // Generate PDF using html2pdf
    const element = document.getElementById("pdf-content");

    let opt = {
      margin: [10, 10, 10, 10],
      filename: "day_book_report.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }, // A4 size in portrait
    };

    html2pdf()
      .from(element)
      .set(opt)
      .output("blob")
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const newWindow = window.open(url, "_blank");
        if (newWindow) {
          newWindow.onload = function () {
            setTimeout(() => {
              newWindow.print();
            }, 100); // Wait a second for the PDF to load before printing
          };
        } else {
          alert("Please allow popups for this website");
        }
      });
  };

  const onSuccess = () => {
    newToggle();
    getDayBook();
  };

  const handleChange = (e) => {
    const { value } = e.target;
    const { startDate, endDate } = date;
    setSelectCategory(value);
    if (startDate != "" && endDate != "") {
      getRangeValue(startDate, endDate, value);
    } else {
      getRangeValue("", "", value);
    }
  };

  const handleSync = async (record) => {
    const { created_at } = record;
    setSyncLoading(true);
    setSyncIdx((prev) => ({ ...prev, [created_at]: created_at }));
    await submitTransaction({ record, balance: state.datebook, dispatch });
    let copy = JSON.parse(JSON.stringify(syncIdx));
    delete copy[created_at];
    setSyncIdx(copy);
  };

  return (
    <Box sx={{ mt: "30px" }}>
      {isOnline && (
        <Box>
          <Grid container columns={24} spacing={2}>
            <Grid item lg={7} md={12} xs={24}>
              <ProfitBox>
                <img src={Profit} alt="profit" />
                <Box>
                  <Typography sx={{ color: "white" }}>Profit :</Typography>
                  <ValueBox>
                    <Typography>{state?.profit}</Typography>
                  </ValueBox>
                </Box>
              </ProfitBox>
            </Grid>
            <Grid item lg={7} md={12} xs={24}>
              <ProfitBox sx={{ background: "#e74c3c" }}>
                <img src={Loss} alt="loss" />
                <Box>
                  <Typography sx={{ color: "white" }}>Loss :</Typography>
                  <ValueBox>
                    <Typography>{state?.loss}</Typography>
                  </ValueBox>
                </Box>
              </ProfitBox>
            </Grid>
            <Grid
              item
              lg={5}
              md={12}
              xs={24}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Btn variant="contained" sx={{ mb: 2 }} onClick={printDoc}>
                <LoopIcon sx={{ mr: "5px" }} />
                Generate Report
              </Btn>
              <Btn variant="contained" onClick={() => toggle("listModal")}>
                Categories List
              </Btn>
            </Grid>
            <Grid
              item
              lg={5}
              md={12}
              xs={24}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Btn
                fullWidth
                variant="contained"
                sx={{ mb: 2 }}
                onClick={transToggle}
              >
                <ControlPointIcon sx={{ mr: 0.5 }} />
                Add Transaction
              </Btn>
              <Btn
                fullWidth
                variant="contained"
                onClick={() => toggle("categoryModal")}
              >
                <ControlPointIcon sx={{ mr: "5px" }} />
                Add Category
              </Btn>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item md={4} xs={12}>
              <Typography>From</Typography>
              <TextField
                sx={{
                  background: "#fff",
                  borderBottom: "1px solid #757575",
                  width: "100%",
                  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
                  borderRadius: "4px",
                  "& label": {
                    color: "rgba(0, 0, 0, 0.6)",
                  },
                  "& div": {
                    "& fieldset": {
                      borderColor: "rgba(0, 0, 0, 0.6)",
                    },
                  },
                }}
                type="date"
                name="startDate"
                onChange={handleDateChange}
                value={date.startDate}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Typography>To</Typography>
              <TextField
                sx={{
                  background: "#fff",
                  borderBottom: "1px solid #757575",
                  width: "100%",
                  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
                  borderRadius: "4px",
                  "& label": {
                    color: "rgba(0, 0, 0, 0.6)",
                  },
                  "& div": {
                    "& fieldset": {
                      borderColor: "rgba(0, 0, 0, 0.6)",
                    },
                  },
                }}
                type="date"
                name="endDate"
                onChange={handleDateChange}
                value={date.endDate}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid
              item
              md={4}
              xs={12}
              sx={{ display: "flex", alignItems: "flex-end" }}
            >
              <FormControl fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  sx={{ background: "white" }}
                  label="Select Category"
                  value={transaction.category || ""}
                  onChange={handleChange}
                >
                  <MenuItem value="">None</MenuItem>
                  {categories.map((item, i) => {
                    return (
                      <MenuItem key={i} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid sx={{ mt: 1.5 }} container spacing={1}>
            <Grid item lg={3} md={4} sm={6} xs={6}>
              <CardBox sx={{ borderBottom: "2px solid #4EAF50" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <img
                    height="30px"
                    width="30px"
                    src={Incoming}
                    alt="incoming"
                  />
                  <Typography>Incoming</Typography>
                </Box>
                <CardValues>
                  <Typography>{state?.incoming}</Typography>
                </CardValues>
              </CardBox>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={6}>
              <CardBox style={{ borderBottom: "2px solid #DE4D4D" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <img height="30px" width="30px" src={Outgoing} alt="out" />
                  <Typography>Outgoing</Typography>
                </Box>
                <CardValues>
                  <Typography>{state?.outgoing}</Typography>
                </CardValues>
              </CardBox>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={6}>
              <CardBox sx={{ borderBottom: "2px solid #4EAF50" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <img height="30px" width="30px" src={Balance} alt="balance" />
                  <Typography>Balance</Typography>
                </Box>
                <CardValues>
                  <Typography>{state?.balance}</Typography>
                </CardValues>
              </CardBox>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={6}>
              <CardBox sx={{ borderBottom: "2px solid #DE934D" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <img height="30px" width="30px" src={Bring} alt="Bring" />
                  <Typography>Brought Forward</Typography>
                </Box>
                <CardValues sx={{ mt: "2px" }}>
                  <Typography>{state?.broughtForward}</Typography>
                </CardValues>
              </CardBox>
            </Grid>
          </Grid>
          {transactions.length > 0 && (
            <Box sx={{ my: 1, display: "flex", justifyContent: "end" }}>
              <Button
                variant="contained"
                size="small"
                sx={{ textTransform: "none" }}
                onClick={toggleOffline}
              >
                {showOffline
                  ? "Hide Offline Transactions"
                  : "Show Offline Transactions"}
              </Button>
            </Box>
          )}
        </Box>
      )}
      {(!isOnline || showOffline) && (
        <Stack width="100%" spacing={2} mb="20px">
          {!isOnline && (
            <Stack direction="row" width="100%" justifyContent="space-between">
              <Typography variant="h6" sx={{ color: "#4eaf51" }}>
                Offline Transactions
              </Typography>
              <Btn
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={transToggle}
              >
                <ControlPointIcon sx={{ mr: 0.5 }} />
                Add Transaction
              </Btn>
            </Stack>
          )}
          {!state.loading && showOffline && (
            <Typography variant="h6" sx={{ mt: -5, color: "#4eaf51" }}>
              Offline Transactions
            </Typography>
          )}

          <DataTableComponent
            columns={offlineCols}
            data={transactions}
            customStyles={customStyles}
            highlightOnHover
          />
        </Stack>
      )}

      {isOnline && !showOffline && (
        <Box>
          <Stack alignItems="center" justifyContent="center">
            <ClipLoader size={50} color="#4DAF51" loading={state.loading} />
          </Stack>
          {!state.loading && (
            <DataTableComponent
              columns={columns}
              data={searchedItems()}
              customStyles={customStyles}
              highlightOnHover
            />
          )}
        </Box>
      )}

      {state.categoryModal && (
        <AddCategory onClose={() => toggle("categoryModal")} />
      )}
      {state.listModal && (
        <CategoriesList onClose={() => toggle("listModal")} />
      )}

      {transModal && (
        <AddTransaction
          onClose={transToggle}
          onSuccess={recordAdded}
          balance={state.datebook}
          status={isOnline}
        />
      )}
      {modal && (
        <UpdateTransaction
          row={selected}
          onClose={newToggle}
          status={isOnline}
          idx={selIndex}
          onSuccess={onSuccess}
        />
      )}
      {openModal && (
        <Dialog open={open} onClose={openModelHandler}>
          <DialogContent>
            <img
              src={selectedImg}
              alt="Popup"
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
            />
          </DialogContent>
        </Dialog>
      )}

      {deleteModal && (
        <DeleteDialog
          title="Delete Transaction"
          open={true}
          onClose={deleteToggle}
          onClickYes={handleDelete}
        />
      )}
    </Box>
  );
}

export default dailyBook;
